// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/work-oder/${file}.vue`);

export default [
    {
        path: "/work-order",
        name: "work-order",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-list"),
        },
    },
    {
        path: "/work-order-draft",
        name: "work-order-draft-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-draft-list"),
        },
    },
    {
        path: "/work-order-open",
        name: "work-order-open-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-open-list"),
        },
    },
    {
        path: "/work-order-completed",
        name: "work-order-completed-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-completed-list"),
        },
    },


];